<template>
  <div class="container">
    <div class="item">
      <label>原手机号：</label
      ><el-input placeholder="请输入原手机号" v-model="oldPhone"></el-input>
    </div>
    <div class="item">
      <label>新手机号：</label>
      <div class="flex newPhone">
        <el-input placeholder="请输入新手机号" v-model="newPhone"></el-input>
        <span class="code" v-if="show" @click="getCode">发送验证码</span>
        <span class="code" v-else>{{ times }}</span>
      </div>
    </div>
    <div class="item">
      <label>验证码：</label
      ><el-input placeholder="请输入验证码" v-model="code"></el-input>
    </div>
    <el-button type="primary" @click="saveBindPhone">提交</el-button>
  </div>
</template>

<script>
export default {
  name: "ChangePhone",
  data() {
    return {
      newPhone: "",
      oldPhone: "",
      code: "",
      times: 60,
      show: true,
    };
  },
  mounted() {
    this.getInfo();
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    getInfo() {
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then(res => {
        this.yuanPhone = res.data.phone;
      });
    },
    saveBindPhone() {
      if (!this.oldPhone) {
        this.$message.error("请输入原手机号");
        return;
      }
      if (this.oldPhone != this.yuanPhone) {
        this.$message.error("原手机号不正确");
        return;
      }
      if (this.oldPhone.length != 11) {
        this.$message.error("原手机号不正确");
        return;
      }
      let myreg = /^[1][3,4,5,6.7,8,9][0-9]{9}$/;
      if (!myreg.test(this.oldPhone)) {
        this.$message.error("原手机号格式不正确");
        return;
      }
      if (!this.newPhone) {
        this.$message.error("请输入新手机号");
        return;
      }
      if (this.newPhone.length != 11) {
        this.$message.error("新手机号不正确");
        return;
      }
      if (!myreg.test(this.newPhone)) {
        this.$message.error("新手机号格式不正确");
        return;
      }
      if (!this.code) {
        this.$message.error("请输入验证码");
        return;
      }
      let formData = new FormData();
      formData.append("newMobile", this.newPhone);
      formData.append("oldMobile", this.oldPhone);
      formData.append("smsCode", this.code);
      this.$http({
        url: "api/v1/user/changephone",
        method: "POST",
        data: formData,
      }).then(res => {
        if (res.code == 200) {
          this.$message.success("修改成功");
          this.newPhone = "";
          this.oldPhone = "";
          this.code = "";
          this.$emit("childByPhone", res.code);
        }
      });
    },
    getCode() {
      if (!this.newPhone) {
        this.$message.error("请输入新手机号");
        return;
      }
      this.times = 60;
      let formData = new FormData();
      formData.append("mobilePhone", this.newPhone);

      this.$http({
        url: "api/v1/user/sendCode",
        method: "POST",
        data: formData,
      }).then(res => {
        this.show = false;
        this.timer = setInterval(() => {
          this.times--;
          if (this.times === 0) {
            this.show = true;
            clearInterval(this.timer);
          }
        }, 1000);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding-top: 50px;
  padding-left: 40px;
  .item {
    display: flex;
    align-items: center;
    font-size: 14px;
    width: 440px;
    margin-bottom: 15px;
    label {
      display: inline-block;
      width: 80px;
      text-align: right;
    }
    ::v-deep .el-input {
      flex: 1;
    }
    .newPhone {
      align-items: center;
      position: relative;
      flex: 1;
      .code {
        position: absolute;
        right: 0;
        padding: 0 20px;
        color: #2d8cf0;
        top: 0;
        line-height: 40px;
        cursor: pointer;
        &::after {
          position: absolute;
          left: 0;
          width: 1px;
          height: 20px;
          background: #eee;
          content: "";
          top: 10px;
        }
      }
    }
  }
  .el-button {
    margin-left: 80px;
  }
}
</style>
